import { AnimatedStat } from './AnimatedStat';

export default AnimatedStat;
